<template>
  <div id="login" class="d-flex sd-flex-direction-column min-height align-items-center">
    <vue-headful title="Login" />
    <header class="w-100">
      <div class="container-fluid px-4">
        <div class="icon-wrapper derect-logo">
          <router-link :to="{ name: 'choose-branch' }" title="Inloggen" class="text-brown">
            <svg-icon icon="derect_logo"></svg-icon>
            <span>Direct een extra kracht</span>
          </router-link>
        </div>
      </div>
    </header>
    <div class="py-5 px-4 container-fluid margin-unset">
      <h2 class="sd-title bold white text-center large margin-bottom-2">
        Welkom bij Derect!
      </h2>
      <form @submit.prevent="onSubmit" class="sd-container bg-white margin-bottom-0 sd-form">
        <NotificationContainer />
        <div class="sd-input mb-4 pb-1">
          <label for="login-password">E-mailadres</label>
          <input type="email" v-model="form.email" class="form-control" placeholder="E-mailadres" required autocomplete="nope"/>
        </div>
        <div class="pb-1 sd-input">
          <label for="login-password">Wachtwoord</label>
          <div class="form-group w-square-icon mb-4">
            <input v-bind:type="[!pass ? 'text' : 'password']" v-model="form.password" class="form-control" placeholder="Wachtwoord" required autocomplete="nope" name="login-password" id="login-password"/>
            <div class="icon-wrapper eye position-absolute align-self-center" v-on:click="pass = false" v-if="pass" v-ripple="'rgba(255, 255, 255, 0.35)'">
              <svg-icon icon="eye" />
            </div>
            <div class="icon-wrapper eye shown position-absolute align-self-center" v-on:click="pass = true" v-else v-ripple="'rgba(255, 255, 255, 0.35)'">
              <span><svg-icon icon="eye_hidden" /></span>
            </div>
          </div>
        </div>
        <button type="submit" class="btn btn-warning btn-block mb-3" v-ripple="'rgba(255, 255, 255, 0.35)'">
          Login
        </button>
        <div class="text-center small">
          <router-link :to="{ name: 'forgot-password' }" class="text-derect" v-ripple="'rgba(255, 255, 255, 0.35)'">
            <strong>Wachtwoord vergeten?</strong>
          </router-link>
        </div>
      </form>
    </div>
    <footer class="position-fixed bg-white w-100">
      <div class="container-fluid text-center">
        <p>
          <router-link :to="{ name: 'choose-branch' }" title="Heb je nog geen account? Registreer hier" class="text-derect" v-ripple="'rgba(255, 255, 255, 0.35)'">
            Heb je nog geen account?
            <strong>Registreer hier</strong>
          </router-link>
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      center: true,
      form: {
        app_id: "fake-app-id-3940256099942544~3347511713",
        email: "",
        password: ""
      },
      pass: true,
      social: true
    };
  },
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    async fetchData() {
      if (localStorage.getItem("user-login")) {
        let user_login = JSON.parse(localStorage.getItem("user-login"));
        this.form.email = user_login.email ? user_login.email : "";
      }
      this.$store.state.loading = false;
    },
    async onSubmit() {
      this.$store.state.loading = true;
      await this.verifyUserEmail(this.form.email);
      await this.loginUser(this.form);
      await this.userToken();

      if (typeof dataLayer !== "undefined") {
        const user = JSON.parse(localStorage.getItem("user"));
        if (user && Number(user.type) === 1) {
          dataLayer.push({
            event: "TeacherSignIn",
            eventCategory: "Teacher",
            eventAction: "Teacher - Sign in",
            eventLabel: "",
            eventValue: "1"
          });
        } else if (user && Number(user.type) === 2) {
          dataLayer.push({
            event: "SchoolSignIn",
            eventCategory: "School",
            eventAction: "School - Sign in",
            eventLabel: "",
            eventValue: "1"
          });
        }
      }
    }
  }
};
</script>

<style scoped>
::v-deep body.bg-image #app {
  color: red;
}

.margin-unset {
  margin-top: unset !important;
  margin-bottom: unset !important;
}

header {
  padding-top: 30px;
}

.derect-logo a {
  color: unset;
}

.derect-logo span {
  display: block;
  font-size: 10px;
  font-weight: normal;
}

p {
  font: 14px/1 "Real Head Pro";
  font-weight: 200;
  margin-bottom: 0;
  color: #64513d;
}

.margin-bottom-0 {
  margin-bottom: 0;
}

.margin-bottom-2 {
  margin-bottom: 2rem;
}

footer {
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>
